export default "__VITE_ASSET__BKaZX5Wu__"